import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/metaPixel';

// Dispara Meta Pixel PageView en cada cambio de ruta SPA.
// trackPageView ya respeta el consentimiento de marketing internamente,
// así que solo dispara si el usuario aceptó cookies de marketing.
export default function MetaPixelRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname]);

  return null;
}
